/**
 * EndNode - Modern end node
 */

import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { IconPlayerStop } from '@tabler/icons-react';

const EndNode = ({ data, selected }) => {
  return (
    <div className={`afc-node afc-node-end ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="afc-handle afc-handle-target"
      />
      <div className="afc-node-inner">
        <div className="afc-node-icon-wrapper end">
          <IconPlayerStop size={20} stroke={1.5} />
        </div>
        <span className="afc-node-label">{data.label}</span>
      </div>
    </div>
  );
};

export default memo(EndNode);
